<template>
  <overview-layout :tableCfg="tableCfg">
  </overview-layout>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import OverviewLayout from '../../components/OverviewLayout'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'university_overview',
  mixins: [OverviewMixin],
  components: {
    OverviewLayout
  },
  data () {
    return {
      tableCfg: FieldDefs
    }
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?18e4c858